module.exports = __webpack_public_path__ + "img/unidad-2.7c0c7642.png";